module.exports = __webpack_public_path__ + "static/img/nodata.fd0cc022.svg";